import React, { useState } from "react";
import axios from "axios";
import userAuthenticationConfig from "../../../utils/userAuthenticationConfig";
import TwoFa from "../../elements/twoFa/TwoFa";
import DialogModal from "../../elements/dialogModal/DialogModal";
import { TextField } from "@material-ui/core";
import DefaultButton from "../../styles/materialButtonStyle";
import { check2FA } from "../../../utils/check2FA";
import getUserInfo from "../../../utils/getUserInfo";
import { useTranslation } from "react-i18next";

import { StyledBlockAction, StyledInputBlock } from "../../styles/styledTabsForm";
import { parseAxiosError } from "../../../utils/response";
import { STANDARD_ERRORS_WAY } from "../../../utils/consts";
import { StyledSwitchWrapper } from "../../masterBalances/styledMasterBalances";
import MaterialSwitch from "../../styles/materialSwitch";

const FeeEditForm = ({ fee, notification, setNotification, url }) => {
  const { t } = useTranslation("feePage");

  const [open, setOpen] = useState(false);
  const [error, setError] = useState({});

  const [submitData, setSubmitData] = useState({
    percent: null,
    constant: null,
    min: null,
    max: null,
    active: fee.active
  });

  const inputProps = {
    step: "any"
  };

  const handleSave = async (event) => {
    event.preventDefault();

    let check2Fa = await check2FA(getUserInfo()["userId"], event.target.twofa.value);

    if (check2Fa.error) {
      setNotification({ ...notification, visible: true, type: "error", message: check2Fa.error });
      return;
    }

    axios.put(url + fee.id, submitData, userAuthenticationConfig()).then(response => {
      if (response.status === 200) {
        setOpen(false);
        setNotification({ ...notification, visible: true, type: "success", message: t("details.changeForm.success") });
      }
    }).catch(error => {
      setOpen(false);
      parseAxiosError(eval(STANDARD_ERRORS_WAY), notification, setNotification);
    });
  };

  return (
    <>
      <DialogModal
        open={open}
        setOpen={setOpen}
        title={t("details.changeForm.twoFa")}
        content={<TwoFa
          handleSubmit={handleSave}
          error={error}
        />}
      />
      <StyledInputBlock
        as="form"
        onSubmit={event => {
          event.preventDefault();

          setSubmitData(prevState => ({
            ...prevState,
            percent: event.target.percent.value,
            constant: event.target.constant.value,
            min: event.target.min.value,
            max: event.target.max.value,
          }));

          setOpen(true);
        }}
      >
        <TextField
          className="grid-form__input"
          variant="filled"
          label={t("details.changeForm.percent")}
          id="percent"
          type="number"
          inputProps={inputProps}
          name="percent"
          defaultValue={fee.percent * 100}
        />
        <TextField
          className="grid-form__input"
          variant="filled"
          label={t("details.changeForm.constant")}
          id="constant"
          type="number"
          inputProps={inputProps}
          name="constant"
          defaultValue={fee.constant}
        />
        <TextField
          className="grid-form__input"
          variant="filled"
          label={t("details.changeForm.min")}
          id="min"
          type="number"
          name="min"
          defaultValue={fee.min}
        />
        <TextField
          className="grid-form__input"
          variant="filled"
          label={t("details.changeForm.max")}
          id="max"
          type="number"
          name="max"
          defaultValue={fee.max}
        />
        <StyledSwitchWrapper>
          <div>
            {t("details.changeForm.active")}
          </div>
          <MaterialSwitch
            id="baseFeeActivity"
            name="Base fee activity"
            checked={submitData.active}
            onChange={event => setSubmitData(prevState => ({ ...prevState, active: event.target.checked }))}
            label={t("details.changeForm.active")}
          />
        </StyledSwitchWrapper>
        <StyledBlockAction>
          <DefaultButton
            color="success"
            type="submit"
          >
            {t("details.changeForm.save")}
          </DefaultButton>
        </StyledBlockAction>
      </StyledInputBlock>
    </>
  );
};

export default FeeEditForm;